var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "".concat(props.prefix || "", "print_svg__a")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.526 0c1.05 0 1.902.864 1.902 1.93v3.519a.53.53 0 0 1 0 .133h1.203c.9 0 1.76.365 2.393 1.012.633.648.984 1.525.976 2.436v3.992c-.006.978-.786 1.77-1.75 1.775h-2.802v3.766A1.436 1.436 0 0 1 16.022 20H5.978c-.784 0-1.42-.642-1.426-1.437v-3.807H1.75C.786 14.751.006 13.96 0 12.981V8.989c.006-1.883 1.512-3.407 3.368-3.407h1.153V1.93C4.521.864 5.373 0 6.423 0h9.103Zm.152 12.006H6.322v6.157h9.356v-6.157Zm2.953-4.648H3.368a1.61 1.61 0 0 0-1.598 1.61v3.992h2.782v-2.79h12.896v2.79l2.782-.02V8.969a1.61 1.61 0 0 0-1.599-1.611Zm-.12.841c.373 0 .677.308.677.688 0 .38-.304.687-.678.687a.683.683 0 0 1-.678-.687c0-.38.304-.688.678-.688Zm-2.954-6.403H6.453a.132.132 0 0 0-.131.133v3.52c0 .074.059.133.131.133h9.104c.072 0 .131-.06.131-.133v-3.52a.132.132 0 0 0-.131-.133Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "".concat(props.prefix || "", "print_svg__b")
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0v24H0V0h24Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "print_svg__a)"),
    transform: "translate(1 2)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v20H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "print_svg__b)"),
    transform: "translate(-1 -2)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 2h22v20H1V2z"
  })))));
};
export default SvgPrint;